import axios from 'axios';
import { config } from '../../Configs';

export const ValidateCampaignAPI = async ({
  reason,
  contractId = null,
  token = null,
  dryRun = false
}) => {
  try {
    const configObj = {};

    if (token) {
      configObj.headers = {
        Authorization: token
      };
    }

    const body = { reason, dryRun };
    if (contractId) {
      body.contractId = contractId;
    }

    const response = await axios.post(
      `${config.api.url}/campaigns`,
      body,
      configObj
    );

    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error };
  }
};
